<template>
  <div class="container category-main-container" v-bind:style="'direction:' + direction">
    <button type="button" class="btn btn-link mobile-btn-categories" @click="mobileShowCategoryBtn()">
      <i :class="direction === 'rtl'? 'fa fa-arrow-circle-left':'fa fa-arrow-circle-right'"></i> 
    </button>
    <div class="row d-flex mobile-category-row">
      <div :style="showCategoriesMobile? 'display:block;':'display:none;'">
        <div class="list-group">
            <span class="list-group-item active list-category-head">{{direction === 'rtl' ? 'קטגוריות' : 'Kатегории'}}</span>
            <a href="javascript:void(0)" class="list-group-item" :ref="cat._id" v-for="cat in categories" v-bind:key="cat._id" @click="categoryHandler(cat._id)" >{{cat.title}}</a>
        </div>
      </div>
      <div :class="'col-md-3 list-categories-col'">
        <div class="list-group">
            <span class="list-group-item active list-category-head">{{direction === 'rtl' ? 'קטגוריות' : 'Kатегории'}}</span>
            <a href="javascript:void(0)" class="list-group-item" :ref="cat._id" v-for="cat in categories" v-bind:key="cat._id" @click="categoryHandler(cat._id)" >{{cat.title}}</a>
        </div>
      </div>
      <div class="col-md-9">
        <ul>
          <li v-for="article in articles" v-bind:key="article._id">
            <router-link class="nav-link" :to="{name: 'article', params: {article_id: article._id}}">
              <h3>{{article.title}}</h3>
              <div v-html="article.short_description"></div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>   
  </div>
</template>

<script>
import { getDataFromServer } from '../utils/DataProvider'
  export default {
      data: () => {
          return{
              articles: [],
              categories: [],
              direction: '',
              selectedCategory: '',
              showCategoriesMobile: false
          }
      },
      methods:{
        categoryHandler(id){
          this.selectedCategory = id
          this.getArticles(id)
        },
        getCategories(){
            console.log("get categories by land: ", this.$store.getters.CURRENT_LANGUAGE )
            getDataFromServer('get_category_bylanguage', this.$store.getters.CURRENT_LANGUAGE)
            .then(obj => { 
                console.log("get categories list: ", obj.data)
              if(obj.data.success === true){            
                this.categories = obj.data.data                
                this.selectedCategory = this.$route.params.category_id ===  undefined ? obj.data.data[0]._id : this.$route.params.category_id
                this.getArticles();
                
                this.$nextTick(()=>{                  
                  this.$refs[this.selectedCategory][0].focus();
                })
                
                console.log("get categories list: ", obj.data.data)
                this.direction = this.$store.getters.CURRENT_LANGUAGE === 'he_IL' ? 'rtl':'ltr';         
              }
              else{
                this.flash('get categories error: ' + obj.data.text , 'error', {timeout: 5000})
              }          
            })
            .catch(err => { 
              this.flash('get categories error: ' + obj.data.text , 'error', {timeout: 5000})
          })
        },

        getArticles(categoryId){
          console.log("category id: ", this.selectedCategory);
          getDataFromServer('get_articles_by_categoryid', {id: this.selectedCategory})
          .then(obj => { 
            console.log("get articles: ", obj.data)
            if(obj.data.success === true){             
              
              this.articles = obj.data.data
              console.log("get articles: ", obj.data.data)
              this.direction = this.$store.getters.CURRENT_LANGUAGE === 'he_IL' ? 'rtl':'ltr';         
            }
            else{
              this.flash('get articles error: ' + obj.data.text , 'error', {timeout: 5000})
            }          
          })
          .catch(err => { 
            this.flash('get articles error: ' + obj.data.text , 'error', {timeout: 5000})
          })
        },

        mobileShowCategoryBtn(){
          this.showCategoriesMobile = !this.showCategoriesMobile
        }
      },
      created(){
        console.log("get_articles_by_categoryid")
        if(this.$store.getters.CURRENT_LANGUAGE === ''){
          this.$store.subscribe((mutation, state) => {
            if(mutation.type === 'SET_CURRENT_LANGUAGE'){
              console.log("created footer subscribe SET_CURRENT_LANGUAGE")           
              this.getCategories()           
            }
          })      
        }else{
          this.getCategories()
        }
        
        //this.getArticles(this.$route.params.category_id)
             
      }
  }
</script>

<style scoped>
    .category-main-container{
        margin-top: 150px;
        background-color: #fff;
        border-radius: 6px;
        padding: 60px 20px;
        margin-bottom: 30px;
    }

    .category-main-container a:hover,
    .category-main-container a:active,
    .category-main-container a:focus{
          color: #666;
    }

    .category-main-container h3{
      margin-bottom: 5px;
      font-size: 18px;
    }

    .category-main-container ul{      
      list-style-type: none;
    }

    .container.category-main-container ul li{
      margin-bottom: 20px;
    }

    .list-group-item.active, 
    .list-group-item.active:hover, 
    .list-group-item.active:focus{
      background-color: #3fbbc0 !important;
      border-color:#3fbbc0 !important;
    }

    .list-category-head{
      color: #fff;
      font-weight: bold;
    }
    
    .mobile-btn-categories{
        display: none;
    }

    .list-categories-col{
      display: block;
    }

    @media screen and (max-width: 767px){
      .mobile-category-row{
        position: relative;        
        -webkit-transition: all 0.25s ease-out;
        -moz-transition: all 0.25s ease-out;
        transition: all 0.25s ease-out;
      }

      .mobile-btn-categories{
        display: block;        
      }

      .mobile-btn-categories i{
        color: #3fbbc0;
        font-size: 30px;
      }

      .list-categories-col{
        display: none;
      }

      .category-main-container{
        margin-top: 90px;
      }
    }
    
</style>